import { render } from "./instruction-page.vue?vue&type=template&id=3c168c29"
import script from "./instruction-page.vue?vue&type=script&lang=js"
export * from "./instruction-page.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__